import { FC } from "react";
import { Tabs } from "@rothoblaas/design-system";
import useI18n from "../../../../../hooks/useTranslations";
import AdminGammaMValuesTab from "../AdminGammaMValuesTab";
import AdminKmodValuesTab from "../AdminKmodValuesTab";
import AdminLoadDurationClassesTab from "../AdminLoadDurationClassesTab";
import AdminServiceClassesTab from "../AdminServiceClassesTab";
import AdminStandardsTab from "../AdminStandardsTab";

const AdminReferenceTab: FC = () => {
  const { translation: t } = useI18n();

  return (
    <Tabs.SubTab>
      <Tabs renderMode="eager"
        urlParameter="reference_tab"
        tabs={[
          { title: t.lockCalculatorModule.admin.reference.standards },
          { title: t.lockCalculatorModule.admin.reference.serviceClasses },
          { title: t.lockCalculatorModule.admin.reference.loadDurationClasses },
          { title: t.lockCalculatorModule.admin.coefficients.kmodValues },
          { title: t.lockCalculatorModule.admin.coefficients.gammaMValues },
        ]}
        contents={[
          <AdminStandardsTab />,
          <AdminServiceClassesTab />,
          <AdminLoadDurationClassesTab />,
          <AdminKmodValuesTab />,
          <AdminGammaMValuesTab />,
        ]}
      />
    </Tabs.SubTab>
  );
};

export default AdminReferenceTab;
